import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { AlertPreviewStackComponent } from '../alert-preview-stack/alert-preview-stack.component';
import { LiveAlertsService } from '../../services/live-alerts.service';

// The real end-user surface (DEV-1165 Phase 2) — added as a sibling of <router-outlet> in
// main-page.component.html so it persists across every routed page. Reuses the same toast-card
// markup the admin preview dialog/tab already use (AlertPreviewStackComponent); this component's
// own job is just fixed-position placement plus wiring to LiveAlertsService (no loading/error
// chrome for a background site-wide widget — nothing renders until there's something to show).
@Component({
  selector: 'app-alert-toast-stack',
  standalone: true,
  imports: [AsyncPipe, AlertPreviewStackComponent],
  templateUrl: './alert-toast-stack.component.html',
  styleUrl: './alert-toast-stack.component.scss'
})
export class AlertToastStackComponent {
  private liveAlertsService = inject(LiveAlertsService);

  liveAlerts$ = this.liveAlertsService.liveAlerts$;

  dismiss(alertId: number) {
    this.liveAlertsService.dismiss(alertId);
  }
}
